import { render, staticRenderFns } from "./DetailAwardSection.vue?vue&type=template&id=eb47f1d2"
import script from "./DetailAwardSection.vue?vue&type=script&lang=js"
export * from "./DetailAwardSection.vue?vue&type=script&lang=js"
import style0 from "./DetailAwardSection.vue?vue&type=style&index=0&id=eb47f1d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports